// eslint-disable-next-line no-unused-vars

export default function TabContent({
  outputRef,
  contentData,
  profileData,
  isSocialPost,
  contentTypeLabels,
  contentWordCount,
  codeViewContent,
  showCodeView,
  isReading,
  isCodeViewInitialized,
  handleCopy,
  toggleReadOutloud,
  setShowCodeView,
  setIsCodeViewInitialized,
  setCodeViewContent,
  decodeHTMLEntities,
  // handleImageDownload,
  handleExportPDF,
  onPostToWebClick,
  setShowDeleteModal,
  planName,
  navigate
}) {
  const {
    content_type,
    title,
    slug,
    excerpt,
    ai_summary,
    content,
    head,
    keywords,
    // featured_image,
    // image_alt
  } = contentData;

  return (
    <div className="form-output view-content" ref={outputRef}>
      <h2>{contentTypeLabels[content_type]} Output</h2>

      {/* profile section */}
      <div className="output-section output-row mb-0">
        <div>
          <p className="label">Profile:</p>
          {profileData ? (
            <>
              <p className="profile-name">{profileData.name}</p>
              <p className="profile-description">{profileData.description || 'No description provided.'}</p>
            </>
          ) : (
            <p className="profile-description">No profile selected.</p>
          )}
        </div>

        {/* featured image */}
        {/* {featured_image && (
          <div>
            <p className="label">Featured Image:</p>

            <div className="output-image">
              <img src={featured_image} alt={image_alt || title || 'Image'} />

              {contentData.photographer && contentData.photographer_url && (
                <p>
                  By <a href={contentData.photographer_url} target="_blank" rel="noopener noreferrer">
                    {contentData.photographer}
                  </a> on <a href="https://www.pexels.com" target="_blank" rel="noopener noreferrer">Pexels</a>
                </p>
              )}

              <button onClick={() => handleImageDownload(featured_image)} className="btn-unset">
                <i className="bi bi-download" />
              </button>
            </div>

            {!isSocialPost && (
              <div className="output-value">
                <input
                  type="text"
                  id="output-alt"
                  value={`<img src="${featured_image}" alt="${(image_alt || title || 'Image').replace(/"/g, '&quot;')}">`}
                  readOnly
                />
                <button
                  type="button"
                  className="btn-unset"
                  onClick={() => handleCopy('output-alt')}
                >
                  <i className="bi bi-copy" />
                </button>
              </div>
            )}
          </div>
        )} */}
      </div>

      {/* title */}
      <div className="output-section">
        <label>Title:</label>
        <div className="output-value">
          <input type="text" id="output-title" value={title} readOnly />
          <button className="btn-unset" onClick={() => handleCopy('output-title')}>
            <i className="bi bi-copy" />
          </button>
        </div>
      </div>

      {!isSocialPost && (
        <>
          <div className="output-section">
            <label>Slug:</label>
            <div className="output-value">
              <input type="text" id="output-slug" value={slug} readOnly />
              <button className="btn-unset" onClick={() => handleCopy('output-slug')}>
                <i className="bi bi-copy" />
              </button>
            </div>
          </div>

          <div className="output-section">
            <label>Excerpt:</label>
            <div className="output-value textarea-shorter">
              <textarea id="output-copy-excerpt" value={excerpt} readOnly />
              <button className="btn-unset" onClick={() => handleCopy('output-copy-excerpt')}>
                <i className="bi bi-copy" />
              </button>
            </div>
          </div>
        </>
      )}

      {/* AI summary */}
      {ai_summary && (
        <div className="output-section output-ai-summary">
          <div
            className="ai-summary"
            dangerouslySetInnerHTML={{ __html: decodeHTMLEntities(ai_summary) }}
          />
        </div>
      )}

      {/* Content */}
      <div className="output-section">
        <div className="label-with-toggle">
          <label htmlFor={showCodeView ? 'output-copy' : undefined}>
            Content ({contentWordCount} Words):
          </label>
          <div className="flex">
            <button
              type="button"
              className="btn-unset"
              onClick={(e) => {
                e.preventDefault();
                toggleReadOutloud();
              }}
            >
              {isReading ? 'Stop Reading' : 'Start Reading'}
            </button>

            <button
              type="button"
              className="btn-unset"
              onClick={(e) => {
                e.preventDefault();
                setShowCodeView((prev) => {
                  const goingIntoCodeView = !prev;
                  if (goingIntoCodeView && !isCodeViewInitialized) {
                    setCodeViewContent(
                      content.replace(/<\/(p|h[1-6])>\s*/gi, '</$1>\n\n')
                    );
                    setIsCodeViewInitialized(true);
                  } else {
                    setIsCodeViewInitialized(false);
                  }
                  return goingIntoCodeView;
                });
              }}
            >
              {showCodeView ? 'Show Preview' : 'Show Code'}
            </button>
          </div>

        </div>
        <div className="output-value">
          {showCodeView ? (
            <textarea
              id="output-copy"
              value={codeViewContent}
              style={{ whiteSpace: 'pre-wrap' }}
              readOnly
            />
          ) : (
            <div
              id="output-copy"
              className="html-preview"
              dangerouslySetInnerHTML={{ __html: decodeHTMLEntities(content) }}
            />
          )}
          <button className="btn-unset" onClick={() => handleCopy('output-copy')}>
            <i className="bi bi-copy" />
          </button>
        </div>
      </div>

      <div className="output-section">
        <label>Relevant Keywords:</label>
        <div className="output-value textarea-shorter">
          <textarea
            id="output-keywords"
            value={Array.isArray(keywords) ? keywords.join(', ') : keywords?.split(',').map(k => k.trim()).join(', ')}
            readOnly
          />
          <button className="btn-unset" onClick={() => handleCopy('output-keywords')}>
            <i className="bi bi-copy" />
          </button>
        </div>
      </div>

      {/* Meta Tags */}
      {!isSocialPost && head && head.replace(/\s/g, '').length > 0 && !/^<meta>\s*<\/meta>$/.test(head) && (
        <div className="output-section">
          {head
            .split(/[\n\r]+/)
            .filter(line => line.trim().length > 0)
            .map((meta, i, arr) => {
              // Default label
              let label = "Meta";

              // If this is the last line, label as "Schema"
              if (i === arr.length - 1 && meta.includes('<script type="application/ld+json"')) {
                label = "Schema";
              } else if (/<title>(.*?)<\/title>/i.test(meta)) {
                label = "Meta Title";
              } else if (/name=["']([^"']+)["']/i.test(meta)) {
                label = meta.match(/name=["']([^"']+)["']/i)?.[1].replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
              } else if (/property=["']([^"']+)["']/i.test(meta)) {
                label = meta.match(/property=["']([^"']+)["']/i)?.[1].replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
              } else if (/rel=["']canonical["']/i.test(meta)) {
                label = "Canonical";
              }

              return (
                <div className="output-section" key={i}>
                  <label>{label}:</label>
                  <div className="output-value">
                    <input
                      id={`meta-tag-${i}`}
                      type="text"
                      value={meta}
                      readOnly
                    />
                    <button
                      className="btn-unset"
                      onClick={() => handleCopy(`meta-tag-${i}`)}
                      tabIndex={0}
                      aria-label={`Copy ${label} meta tag`}
                    >
                      <i className="bi bi-copy" />
                    </button>
                  </div>
                </div>
              );
            })}
        </div>
      )}

      <div className="content-actions">
        <button type="button" className="btn-outlined" onClick={() => navigate('/content')}>
          Back to List
        </button>
        <button type="button" className="btn-outlined" onClick={() => navigate('/create')}>
          Create New
        </button>
        <button type="button" className="btn-outlined" onClick={handleExportPDF}>
          Export to PDF
        </button>
        <button type="button" className="btn-outlined" onClick={onPostToWebClick}>
          Post to Web
        </button>
        {planName === 'Pro' && (
          <button
            type="button"
            className="btn-outlined btn-delete"
            onClick={() => setShowDeleteModal(true)}
          >
            Delete
          </button>
        )}
      </div>
    </div>
  );
}
